import React, { useState } from 'react';
import guidelineImg from '../../assets/qc35-time-involvement-guideline.jpg';
import { qc35ContextSummary } from '../../pages/qc35Questions';

// QMM 的時間投入指引——QC35 的三道時間投入題（EP／EP+Manager／EQR）低於指引
// 就要在 Comments 說明，但指引本身（依風險等級的百分比與 EQR 時數）只在 QMM
// 裡。接在 checklist 表格下方，預設就攤開——三道題填之前要先對這張表，收起來
// 等於又要多按一下；不想看的人按一下收掉。上方一行印出這一案用的評級與 EQR
// （QC6/QC7 表單含附錄的現值）——填的人與審核的人看到的是同一把尺。
const Qc35TimeGuideline = ({ ctx = null, hasEngagement = false }) => {
  const [open, setOpen] = useState(true);
  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="text-xs text-blue-600 hover:text-blue-800 underline"
      >
        {open ? 'Hide the Guideline' : 'View the Guideline'}
      </button>
      {open && (
        <div className="mt-2 border border-slate-200 rounded-lg p-3 bg-slate-50 space-y-2">
          {hasEngagement && (
            <p className="text-xs text-slate-600">{qc35ContextSummary(ctx)}</p>
          )}
          <img
            src={guidelineImg}
            alt="QMM guideline on partner, manager and EQR hours over total engagement hours by risk category"
            className="max-w-full rounded border border-slate-200"
          />
        </div>
      )}
    </div>
  );
};

export default Qc35TimeGuideline;
